import React from 'react';

import type { ListType } from '~/components-ds/ReviewList';
import ReviewList from '~/components-ds/ReviewList';
import { MEMBERSHIP_ROUTE } from '~/constants/routes';
import { useAppContent, useExtraInfo } from '~/hooks';

const ReviewMembership: React.FC = () => {
  const { getTextContent } = useAppContent({ basePath: 'dsme.review.fields.membership' });
  const { partnerMembershipNumber } = useExtraInfo();

  const membershipReviewList = [
    {
      label: getTextContent('partnerMembershipNumber'),
      data: partnerMembershipNumber,
    },
  ];

  const list = Object.fromEntries(
    membershipReviewList.map((item, idx) => [
      String(idx),
      {
        id: idx,
        name: item.label,
        label: item.label,
        value: item.data,
      },
    ])
  ) as ListType;

  return <ReviewList list={list} title={getTextContent('title')} editRoute={MEMBERSHIP_ROUTE} />;
};

export default ReviewMembership;
